import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BreadcrumbItem from './BreadcrumbItem';
const defaultItems = [{
  label: 'Furniture',
  link: '/shop'
}];
const Breadcrumb = t0 => {
  const $ = _c(35);
  const {
    color: t1,
    forPage,
    items: initialItems,
    layout: t2,
    loading: t3,
    noPadding: t4,
    withSchema: t5
  } = t0;
  const color = t1 === undefined ? "dark" : t1;
  const layout = t2 === undefined ? "" : t2;
  const loading = t3 === undefined ? false : t3;
  const noPadding = t4 === undefined ? false : t4;
  const withSchema = t5 === undefined ? true : t5;
  const items = initialItems ?? defaultItems;
  const pageBreadcrumbRef = useRef(null);
  let t6;
  if ($[0] !== forPage || $[1] !== items) {
    t6 = forPage === "CategoryDesktop" && items.length >= 2 ? items.slice(1, items.length - 1) : items;
    $[0] = forPage;
    $[1] = items;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const desktopItems = t6;
  let t7;
  if ($[3] !== forPage) {
    t7 = () => {
      if (forPage && ["PDPMobile", "CategoryMobile"].includes(forPage)) {
        const element = pageBreadcrumbRef.current;
        if (element) {
          if (element.scrollWidth > element.clientWidth) {
            element.style.direction = "rtl";
          } else {
            element.style.direction = "ltr";
          }
        }
      }
    };
    $[3] = forPage;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== forPage || $[6] !== items) {
    t8 = [forPage, items];
    $[5] = forPage;
    $[6] = items;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  useEffect(t7, t8);
  const t9 = !noPadding;
  const t10 = layout !== "float";
  const t11 = layout === "float";
  const t12 = color !== "light";
  const t13 = color === "light";
  let t14;
  if ($[8] !== noPadding || $[9] !== t10 || $[10] !== t11 || $[11] !== t12 || $[12] !== t13 || $[13] !== t9) {
    t14 = classNames("z-auto m-0 mt-0 pt-2 pl-5", {
      "min-h-[45px]": t9,
      "min-h-[auto]": noPadding,
      static: t10,
      "absolute top-2.5 left-0 max-[1023px]:relative max-[1023px]:top-0": t11,
      "bg-gray-light9 border-gray-light7 border-b border-t md:pl-[50px]": t12,
      "bg-transparent border-0 [&_a]:text-gray-light1 [&_li:last-child_span]:last:text-gray-light1 [&_a:hover]:text-white sm:pt-0 sm:pl-0 md:mt-2": t13
    });
    $[8] = noPadding;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t13;
    $[13] = t9;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== noPadding) {
    t15 = classNames("list-none text-xs", {
      "m-0 p-0 lg:m-0": noPadding
    });
    $[15] = noPadding;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== withSchema) {
    t16 = withSchema && {
      itemScope: true,
      itemType: "https://schema.org/BreadcrumbList"
    };
    $[17] = withSchema;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== desktopItems || $[20] !== items || $[21] !== loading || $[22] !== withSchema) {
    let t18;
    if ($[24] !== items || $[25] !== loading || $[26] !== withSchema) {
      t18 = (item, index) => <BreadcrumbItem loading={loading} key={item.label} isLast={index === items.length - 1} index={index} withSchema={withSchema} {...item} />;
      $[24] = items;
      $[25] = loading;
      $[26] = withSchema;
      $[27] = t18;
    } else {
      t18 = $[27];
    }
    t17 = desktopItems.map(t18);
    $[19] = desktopItems;
    $[20] = items;
    $[21] = loading;
    $[22] = withSchema;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[28] !== t15 || $[29] !== t16 || $[30] !== t17) {
    t18 = <ol className={t15} {...t16}>{t17}</ol>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t14 || $[33] !== t18) {
    t19 = <div className={t14} ref={pageBreadcrumbRef}>{t18}</div>;
    $[32] = t14;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
};
Breadcrumb.propTypes = {
  color: PropTypes.oneOf(['light', 'dark']),
  layout: PropTypes.string,
  loading: PropTypes.bool,
  forPage: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string.isRequired
  })),
  noPadding: PropTypes.bool,
  withSchema: PropTypes.bool
};
export const BreadcrumbPlaceholder = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.forPage) {
    t0 = props.forPage === "CategoryDesktop" ? [{
      label: "1"
    }] : [{
      label: "1"
    }, {
      label: "2"
    }, {
      label: "3"
    }];
    $[0] = props.forPage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== t0) {
    t1 = <Breadcrumb {...props} loading={true} layout={props.layout} items={t0} />;
    $[2] = props;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
BreadcrumbPlaceholder.propTypes = {
  forPage: PropTypes.string,
  layout: PropTypes.string
};
export default Breadcrumb;